import { createApp } from 'vue';
import MainHeaderSlider from './main-header-slider.vue';

const app = createApp(MainHeaderSlider);

app
    .mixin(window.vueGlobalMixin)
    .mount('#main-header-slider-vue-root');